/* This is just a static page to display when no conversation is selected. */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Tinode from 'tinode-sdk';

import { APP_NAME } from '../config.js';

export default class LogoView extends React.PureComponent {
  render() {
    return (
      <div id="dummy-view">
        <div>
          <h2>Stream Chat</h2>
        </div>
      </div>
    );
  }
};
